import { m } from '~/paraglide/messages'
import { language, platform } from '~/params'

export function LearnMoreButton() {
  return (
    <button
      className="relative flex size-full content-stretch items-center gap-[4px]"
      onClick={() => {
        let subscriptionDetailsPageURL: string
        switch (import.meta.env.MODE) {
          case 'staging':
            subscriptionDetailsPageURL = `https://forest-permanent-paywall-staging.seekrtech.com/${language}/details/`
            break
          case 'production':
            subscriptionDetailsPageURL = `https://forest-permanent-paywall.seekrtech.com/${language}/details/`
            break
          default:
            subscriptionDetailsPageURL = `https://forest-permanent-paywall.seekrtech.com/${language}/details/`
            break
        }
        location.href = `${subscriptionDetailsPageURL}?platform=${platform}`
      }}
    >
      <p className="text-center text-xs text-[#176361]">
        {m.daily_paywall_learn_more_plus()}
      </p>

      <span className="block size-3">
        <svg
          preserveAspectRatio="none"
          width="100%"
          height="100%"
          overflow="visible"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="arrow-right">
            <path
              id="Vector"
              d="M4.45501 9.96L7.71501 6.7C8.10001 6.315 8.10001 5.685 7.71501 5.3L4.45501 2.04"
              stroke="var(--stroke-0, #176361)"
              strokeWidth="1.02857"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_2"
              opacity="0"
              d="M0.514648 11.4854L0.514648 0.514648L11.4854 0.514648L11.4854 11.4854L0.514648 11.4854Z"
              stroke="var(--stroke-0, #176361)"
              strokeWidth="1.02857"
            />
          </g>
        </svg>
      </span>
    </button>
  )
}
